export default "__VITE_ASSET__6bb16a8e__"